<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="scrollbar-track-rounded scrollbar-thin scrollbar-track-transparent scrollbar-thumb-card">
    <app-breadcrumb [items]="breadcrumbItems" (onItemClicked)="onItemClicked($event)"></app-breadcrumb>
    <mat-selection-list #shoes [multiple]="false">
        @for (item of itemsInBox; track item) {
        <div class="mt-1 cursor-pointer flex justify-between items-center h-12 ps-4 pe-0 w-full border hover:bg-gray-200"
            (click)="onChildClicked(item)">
            <div class="content-box-text">{{item.text}}</div>
            <div *ngIf="haveChild(item.id)"><i class="material-icons">keyboard_arrow_right</i>
            </div>
        </div>
        }
    </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="onCancelClick()">{{'COMMON.CANCEL' | translate}}</button>
    <button mat-flat-button color="primary"
        *ngIf="(!isRoot || data.canChooseRoot) && !selectedItem.isReadOnly && canSelected(selectedItem.id)"
        (click)="onSubmit()">{{'COMMON.SAVE'
        | translate}}</button>
</mat-dialog-actions>